import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateData } from '../../Helpers/requests';
import { r2_updateData } from '../../Helpers/r2_requests';

import { APIROOT } from '../../Helpers/configs';
import { GetAuth } from '../../Auth/AuthProvider';
import {
  Box,
  Grid,
  Typography,
  TextField,
  Divider,
  Button,
  Switch,
} from '@mui/material';

import ConstantsAutocomplete from '../CommonComponents/ConstantsAutocomplete';

const ConstantsEdit = (props) => {
  const navigateBack = useNavigate();
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [forceUpdate, setForceUpdate] = useState(1);

  const thisRowData = props.thisRowData;
  const cancelEdit = props.cancelEdit;

  const [active, setActive] = useState(thisRowData.active);
  const [name, setName] = useState(thisRowData.name);
  const [type, setType] = useState(thisRowData.field);

  const handleListChange = (event) => {
    setName(event.target.value);
  };

  const handleChange = (event) => {
    setName(event.target.value);
  };

  const dataBlob = {
    constant: {
      field: type,
      name: name,
    },
  };

  const handleSave = () => {
    const updateType = 'constant';
    // const path = '/admin/constants';
    const uri =
      thisRowData.id === undefined
        ? `/r2_constants`
        : `/r2_constants/${thisRowData.id}`;
    r2_updateData({
      uri: uri,
      dataBlob: dataBlob,
      cancelEdit: cancelEdit,
      setForceUpdate,
      navigateBack,
      path: '/admin/constants',
      logout,
      enqNotification: enqNotification,
      updateMessage: 'Constant updated',
      type: updateType,
    });
  };

  return (
    <Box sx={boxStyle}>
      <Grid container rowGap={2}>
        <Grid
          xs={12}
          md={8}
          sx={{
            border: '1px #c4c4c4 solid',
            // borderBottom: 'none',
            borderRadius: '15px 15px 0 0 ',
            padding: ' 10px 0 0 0 ',
          }}
          item
        >
          <Typography variant='h4'>
            {typeFilterData(type)
              ? `${typeFilterData(type)}: ${name ?? ''}`
              : 'Please select a constant type'}
          </Typography>
        </Grid>
        <Grid
          xs={0}
          md={4}
          item
          sx={{ borderBottom: '1px #c4c4c4 solid' }}
        ></Grid>

        <Grid xs={12} md={6} item>
          <ConstantsAutocomplete
            setByType={(data) => setType(data)}
            nameLabel='Constant Type'
            id='constantType'
            constantsType={thisRowData.field}
          />
        </Grid>

        <Grid xs={12} md={6} item>
          <TextField
            sx={{ width: '80%' }}
            id='name'
            label='Name'
            variant='outlined'
            value={name}
            onChange={(event) => handleChange(event)}
          />
        </Grid>
      </Grid>

      <Divider sx={{ marginTop: '15px' }} />
      <Box align='right'>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ margin: '15px 0 0 10px' }}
        >
          Save
        </Button>
        <Button
          variant='contained'
          color='secondary'
          onClick={cancelEdit}
          sx={{ margin: '15px 0 0 10px' }}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default ConstantsEdit;
const boxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
};

const typeFilterData = (data) => {
  switch (data) {
    case 'CUS_ASSET_COMP':
      return 'Asset Comp';

    case 'CUS_CATEGORIES':
      return 'Categories';

    case 'CUS_REGIONS':
      return 'Regions';

    default:
      break;
  }
};
